export const PM = 'خاص';
export const MESSAGES = 'الرسائل';
export const GROUPS = 'مجموعات';
export const SETTINGS = 'إعدادات';
export const NEW_MESSAGE = 'رسالة جديدة';
export const CREATE_GROUP = 'إنشاء مجموعة';
export const JOIN_GROUP = 'دخول مجموعة';
export const ACCOUNT = 'الحساب';
export const SUPPORT = 'الدعم الفني';
export const SUGGESTIONS = 'المقترحات';
export const DEVICES = 'الأجهزة';
export const LOG_OUT = 'تسجيل خروج';
export const SINGLE_WATCHING = 'يشاهد';
export const SINGLE_TYPING = 'يكتب';
export const PLURAL_WATCHING = 'يشاهدون';
export const PLURAL_TYPING = 'يكتبون';
export const CLICK_CREATE_GROUP = 'انقر انشاء مجموعة';
export const CLICK_JOIN_GROUP = 'انقر دخول مجموعة';
export const LOG_OUT_MESSAGE = 'هل أنت متأكد من تسجيل خروجك؟';
export const NO_PM_CHATS = 'لا يوجد محادثات شخصية';



// WEBPACK FOOTER //
// ./src/lang/ar/left.js